import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { JoinPipe } from './join.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [JoinPipe],
  exports: [JoinPipe],
  providers: []
})
export class JoinPipeModule {}
